import i18n from '@buy-viasat/utils/src/lib/config/i18n';
import enUS from './translations/en-US/translations.json';

i18n.addResourceBundle('en-US', 'translation', enUS);

export default i18n;
